import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { PatientImportListComponent } from './patient-import-list/patient-import-list.component';
import { PatientImportItemListComponent } from './patient-import-item-list/patient-import-item-list.component';
import { PatientImportListService } from 'src/app/core/service/grid-data/grid-data-patient-import.service';
import { PatientImportEditComponent } from './patient-import-edit/patient-import-edit.component';
import { GridStatePersistingService } from 'src/app/core/service/grid-state-persisting';
import { PatientImportItemListService } from 'src/app/core/service/grid-data/grid-data-patient-import-item.service';

@NgModule({
  declarations: [
    PatientImportListComponent,
    PatientImportItemListComponent,
    PatientImportEditComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    PatientImportListComponent,
    PatientImportItemListComponent,
    PatientImportEditComponent
  ],
  providers: [
    PatientImportListService,
    PatientImportItemListService,
    GridStatePersistingService
  ]
})
export class PatientImportModule { }
